import styled from "styled-components";

export const Button = styled.button`
  background-color: grey;
  color: white;
  font-weight: bold;
  padding: 12px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
`;

export const SuccessButton = styled(Button)`
  background: linear-gradient(to right, #8a2be2, pink);
`;

export const WarningButton = styled(Button)`
  background: linear-gradient(to right, rgb(56, 113, 219), rgb(14, 220, 235));
`;
